<template>
  <div id="app">
    <link
      href="https://fonts.googleapis.com/css?family=Oswald:400,700|PT+Sans:400,700&display=swap"
      rel="stylesheet"
    />
    <link
      rel="stylesheet"
      href="//cdn.materialdesignicons.com/5.1.45/css/materialdesignicons.min.css"
    />

    <!-- <div id="nav">
      <router-link to="/">Home</router-link> |
      <router-link to="/about">About</router-link>
    </div> -->
    <theme>
      <router-view />
    </theme>
  </div>
</template>

<script>
import theme from "../src/components/theme";
export default {
  components: {
    theme
  }
};
</script>
